import React, { Component } from "react";
import kyc from "views/profile/img/kyc/kyc.png";
class eKYC extends Component {
  render() {
    return (
      <card className="rounded-12px drop-shadow20 bg-white block lg:p-8 md:p-8 p-5 lg:mt-12 md:mt-12  sm-shadow-none">
        <div className="lg:px-12 md:px-12 pb-4">
          <img
            src={kyc}
            alt="kyccomplete"
            className="w-full h-240px mob-ekyc sm-h190px"
          />

          <div className="flex justify-center mt-8">
            <p className="text-black line-h30 fsize18 sm-fsize14   lg:w-3/4 md:w-3/4 text-center">
              The eKYC process, often called paperless KYC, is the process of
              electronically verifying the credentials of a customer. Kindly
              click on the below button and Proceed.
            </p>
          </div>
          <div class="w-full  flex justify-center w-full mt-10">
            <button className="filled-button w-230px h-47px fsize16 font-semibold rounded-25px">
              COMPLETE YOUR KYC
            </button>
          </div>
        </div>
      </card>
    );
  }
}
export default eKYC;
